import React, { useEffect, useState } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useTeamField } from '@atlassian/jira-issue-field-team/src/services';
import { TEAMS_PLATFORM_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { toIssueKey } from '@atlassian/jira-shared-types';
import { CellWrapper } from '../../../common/cell-wrapper';
import type { TransformedTeamField } from '../../../common/field-types/team';
import type { FieldCellProps, BasicListViewItem } from '../../../common/types';
import { TeamEdit } from './edit/async';
import { TeamRead } from './read';

export const TeamCell = ({
	rowData: issue,
	cellData: field,
	column: { width: preferredWidth },
	editMode,
	setEditMode,
	cellRef,
}: FieldCellProps<BasicListViewItem, TransformedTeamField>) => {
	const [team, setTeam] = useState(field?.value);

	const [{ value }] = useTeamField({
		issueKey: toIssueKey(issue.key),
		fieldKey: field?.fieldId ?? '',
		initialValue: team,
	});

	if (value !== team && fg('jwm_list_new_copy_paste_behaviour')) {
		setTeam(value);
	}

	useEffect(() => {
		setTeam(field?.value);
	}, [field?.value]);

	if (field == null) {
		return null;
	}

	const readContent = <TeamRead team={team} />;

	return (
		<CellWrapper isEditable hasPadding={false} testId="business-fields.ui.team.cell.cell-wrapper">
			{editMode ? (
				<TeamEdit
					issueKey={issue.key}
					fieldKey={field.fieldId}
					team={team}
					onChange={setTeam}
					setEditMode={setEditMode}
					readContent={readContent}
					preferredWidth={preferredWidth}
					cellRef={cellRef}
				/>
			) : (
				readContent
			)}
		</CellWrapper>
	);
};

export const teamCellHandler = {
	[TEAMS_PLATFORM_CF_TYPE]: TeamCell,
};
